<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-26 18:15:08
 * @LastEditTime: 2019-12-18 18:25:44
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div id="page_Container">
    <div class="page">
        <commonSearch :searchType="searchType" :type='styleType' :searchMassage="searchMassage" @goSearch="goSearch"></commonSearch>
        <!--导航栏-->
        <div class="navbar">
            <ul class="nav">
                <li :class="{active:active==0}" @click="queryDataBysales()">销量<img :src="salesicon" class="salesbtn" alt=""></li>
                <li :class="{active:active==1}" @click="queryDataByprice()">价格<img :src="priceicon" class="pricebtn" alt=""></li>
                <li class="nav-img" @click="goevaluation()"><img src="../assets/img/home/listimg.png" class="gobtn" alt="">分类</li>
            </ul>
        </div>
        <div id="main-container">
            <!-- 商品列表 -->
            <div class="goods-container">
                <van-pull-refresh :class="{flexClass:!listShow}" v-model="isLoading" @refresh="onRefresh">
                <van-list v-model="ploading" :finished="finished"  @load="onLoad" :offset="1">
                    <div v-if='listShow'>
                        <div v-for="good in goods" :key="good.id" @click="godetail(good)">
                            <goodCommon :good="good" :disShow="retailStoreProductFlag">
                            </goodCommon>
                        </div>
                    </div>
                </van-list>
                <listBottom v-if='finishedOk && bottomShow'></listBottom>
                <div class="placeholder"></div>
                </van-pull-refresh>
            </div>
            <!-- 无商品 -->
            <div class="nogood" v-if='!listShow'>
                <img :src="noListUrl" alt="">
                <p>暂无商品</p>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
import goodCommon from '@/components/common/goodCommon';
import commonSearch from '@/components/common/commonSearch';
import listBottom from '@/components/common/listBottom';
import { toastLoading, clearToastLoading } from '@/utils/base/utils';
// import * as types from '@/store/modules/types';
import {
    mapActions,
    mapGetters
} from 'vuex';
export default {
    components: {
        goodCommon,
        commonSearch,
        listBottom
    },
    name: 'goodlist',
    data () {
        return {
            bottomShow: false,
            active: 0,
            goods: [],
            searchType: '1',
            searchMassage: '请输入商品名称',
            styleType: '1',
            priceicon: '',
            salesicon: '',
            icon: {
                upsort: require('../assets/img/goods/doneListNomal@3x.png'),
                upsorted: require('../assets/img/goods/doneListNomalAction@3x.png'),
                unsorted: require('../assets/img/goods/pricesort.png'),
                ascending: require('../assets/img/goods/priceascend.png'),
                descending: require('../assets/img/goods/pricedescend.png')
            },
            ispriceascend: false,
            params: {},
            noListUrl: require('../assets/img/myCenter/noList.png'),
            listShow: false,
            list: [],
            loading: false,
            isLoading: false,
            ploading: false,
            finished: true,
            finishedOk: false,
            pageNum: 1,
            pageSize: 5,
            categoryArr: null,
            retailStoreProductFlag: null // 是否是分销产品
        };
    },
    esvReady() {
        const ths = this;
        // if (this.searchInfo.searchFlag && this.searchInfo.searchFlag === 'search') {
        //     ths.searchMassage = this.searchInfo.productName;
        // } else {
        //     ths.setSearchInfo({ ...this.searchInfo, productName: '' });
        // }
        ths.searchMassage = this.searchInfo.productName || '请输入商品名称';
        this.styleType = this.searchInfo.styleType;
        ths.ESVStorage.getSavedValue('id', (data) => {
            if (data < 0) data = '';
            ths.categoryArr = data || '';
            // 获取判断条件
            this.retailStoreProductFlag = this.$route.params.retailStoreProductFlag;

            ths.queryDatafirst();
        });
        ths.priceicon = ths.icon.unsorted;
        ths.salesicon = ths.icon.upsorted;
        console.log('ready');

        // window.addEventListener(
        //     'popstate',
        //     function(e) {
        //         ths.setSearchInfo({ ...this.searchInfo, searchMassage: this.searchMassage });
        //         // ths.$store.commit(types.APP_SEARCH_FLAG, ths.searchMassage);
        //     },
        //     false
        // );
    },
    esvShow() {
        console.log('show');
        console.log(this.$route.query);
        document.title = '商品列表';
        this.ESVStorage.putSavedValue('cTabIndex', 1);
    },
    methods: {
        ...mapActions(['setSearchInfo']),
        goSearch(searchMassage) {
            this.setSearchInfo({ ...this.searchInfo, searchFlag: 'search' });
            if (this.searchInfo.searchType === '1') {
                this.ESVStorage.putSavedValue('searchMassage', searchMassage);
                this.esvBackPage(1);
            } else {
                this.setSearchInfo({ ...this.searchInfo, searchFlag: '' });
                const params = { name: 'OPSearch',
                    params: { retailStoreProductFlag: this.$route.params.retailStoreProductFlag
                    } };
                if (searchMassage === '') {
                    this.esvOpenPage(params);
                } else {
                    this.setSearchInfo({ productName: searchMassage === '请输入商品名称' ? '' : searchMassage, styleType: '2', searchType: '3' });
                    this.esvOpenPage(params);
                }
            }
        },
        // 初始化页面
        queryDatafirst() {
            const ths = this;
            ths.active = 0;
            ths.finished = true;
            ths.listShow = true;
            ths.pageNum = 1;
            ths.params = {
                categoryArr: ths.categoryArr,
                maxNum: 1
            };
            ths.queryData();
        },
        // 按销量排序
        queryDataBysales() {
            const ths = this;
            ths.active = 0;
            ths.goods = [];
            ths.priceicon = ths.icon.unsorted;
            ths.salesicon = ths.icon.upsorted;
            ths.ispriceascend = false;
            ths.loading = true;
            ths.pageNum = 1;
            ths.params = {
                categoryArr: ths.categoryArr,
                maxNum: 1
            };
            ths.queryData();
        },
        // 按价格排序
        queryDataByprice() {
            const ths = this;
            ths.active = 1;
            ths.goods = [];
            ths.salesicon = ths.icon.upsort;
            if (ths.ispriceascend === false) {
                ths.ispriceascend = true;
                ths.priceicon = ths.icon.descending;
                ths.pageNum = 1;
                ths.params = {
                    categoryArr: ths.categoryArr,
                    max: 1
                };
                ths.queryData();
            } else {
                ths.ispriceascend = false;
                ths.priceicon = ths.icon.ascending;
                ths.pageNum = 1;
                ths.params = {
                    categoryArr: ths.categoryArr,
                    min: 1
                };
                ths.queryData();
            }
        },
        // 到商品详情
        godetail: function(item) {
            const ths = this;
            ths.ESVStorage.putSavedValue('goodsId', item.productId);
            ths.esvOpenPage({ name: 'OPGoodsdetail', params: { goodsId: item.productId, retailStoreProductFlag: this.retailStoreProductFlag } });
        },
        queryData() {
            const ths = this;
            ths.bottomShow = false;
            ths.$set(ths.params, 'pageNum', ths.pageNum);
            ths.$set(ths.params, 'pageSize', ths.pageSize);
            if (this.retailStoreProductFlag) {
                this.$set(ths.params, 'retailStoreProductFlag', ths.retailStoreProductFlag);
            }
            if (this.searchInfo.searchFlag && this.searchInfo.searchFlag === 'search') {
                this.params.productName = this.searchInfo.productName;
                this.params.categoryArr = '';
            }
            ths.$doRequest(
                {
                    url: '/elasticsearch/queryProductIndex',
                    params: ths.params,
                    before: function() {
                        ths.loading = toastLoading();
                    },
                    complete: function() {
                        ths.finished = true;
                        ths.ploading = false;
                        clearToastLoading(ths.loading);
                        ths.bottomShow = true;
                    }
                },
                function (data) {
                    console.log(data);
                    const total = parseInt(data.result.total);
                    ths.goods =
                        ths.pageNum === 1
                            ? data.result.list
                            : [...ths.goods, ...data.result.list];
                    if (ths.goods.length < total) {
                        ths.finished = false;
                    } else {
                        ths.finished = true;
                        ths.finishedOk = true;
                    }

                    if (ths.goods.length > 0) {
                        ths.listShow = true;
                    } else {
                        ths.finishedOk = false;
                        ths.listShow = false;
                    }
                }
            );
        },
        // 下拉刷新
        onLoad() {
            console.log('上拉加载');
            this.pageNum++;
            this.queryData();
        },
        onRefresh() {
            setTimeout(() => {
                this.pageNum = 1;
                this.queryData();
                this.loadingTextShow = false;
                this.isLoading = false;
            }, 500);
        },
        // 到分类列表
        goevaluation() {
            const ths = this;
            ths.esvOpenPage('OPPlatform');
        },
        onClickLeft () {
            this.$toast.success('左按钮被点击');
        },
        onClickRight () {
            this.$toast.fail('右按钮被点击');
        }
    },
    computed: {
        ...mapGetters(['searchInfo'])
    }
};
</script>
<style lang="scss" scoped>
#page_Container {
    padding-top: 40px;
    background: #fff;
}
    .goods-container{
        // margin-top: 40px;
        // background-color: #ffffff;
        margin-bottom: 40px;
        // .placeholder{
        //     content: '';
        //     width: 100%;
        //     height: 10px;
        // }
    }
    #main-container {
        background: #f2f2f2;
    }
    .navbar{
        // position: fixed;
        // top: 45px;
        // left: 0;
        height: 40px;
        width: 100%;
        background-color: #fff;
        opacity: 1;
        z-index: 1;
            .nav{
                height: 40px;
                li{
                    height: 40px;
                    line-height: 40px;
                    float: left;
                    width: 33.3%;
                    text-align: center;
                    font-size: 14px;
                    img{
                        vertical-align: middle;
                    }
                    .pricebtn{
                        width: 6px;
                    }
                    .salesbtn {
                        width: 6px;
                        margin-top: 4px;
                    }
                    .gobtn{
                        width: 20px;
                        margin-right: 4px;
                    }
                }
                .nav-img {
                    color: #666666;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .active{
                    color: $primary-color;
                }
            }
        }
        .nogood {
            text-align:center;
            padding-top:121px;
            img {
                width:203px;
            }
            p {
                color:#999;
                padding-top:14px;
                text-align:center;
            }
        }

</style>
